import { app } from '../../../../../app';
import { Controller } from './simulators.controller';

app.component('companyManageApplicationIntegrationDevelopersSimulators', {
    bindings: {
        application: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./simulators.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/simulators/simulators.component.js